import axios from "axios";

const downloadAttendance = (query) => {
  const params = new URLSearchParams(query).toString();
   const response = axios({
      url:`reports/download-attendance?${params}`,
      method:"GET",
      responseType: 'arraybuffer' ,
      headers:{
        "Accept-Language": "en-US,en;q=0.8"
      }
    }).then((response)=>{
      return response.data
    })
    return response
}

const downloadVendorReport = (query) => {
  const params = new URLSearchParams(query).toString();
   const response = axios({
      url:`reports/download-vendor?${params}`,
      method:"GET",
      responseType: 'arraybuffer' ,
      headers:{
        "Accept-Language": "en-US,en;q=0.8"
      }
    }).then((response)=>{
      return response.data
    })
    return response
}

const downloadLeaves = (query) => {
  const params = new URLSearchParams(query).toString();
   const response = axios({
      url:`reports/download-leave?${params}`,
      method:"GET",
      responseType: 'arraybuffer' ,
      headers:{
        "Accept-Language": "en-US,en;q=0.8"
      }
    }).then((response)=>{
      return response.data
    })
    return response
}

const downloadStockReport = (query) => {
  const params = new URLSearchParams(query).toString();
   const response = axios({
      url:`reports/download-stock?${params}`,
      method:"GET",
      responseType: 'arraybuffer' ,
      headers:{
        "Accept-Language": "en-US,en;q=0.8"
      }
    }).then((response)=>{
      return response.data
    })
    return response
}

export {
    downloadAttendance,
    downloadVendorReport,
    downloadLeaves,
    downloadStockReport
}
